/* Write a review.

   The third panel on this page built to the same pattern as the first two,
   and it sends the same way, for the same reason.

   Shopify puts hCaptcha in front of POST /contact. Its script binds by
   looking for form[action*='/contact'] and listening for a submit event on
   the document, so two things have to be true or the post arrives with no
   token and comes back "Missing CAPTCHA token": the panel has to be a real
   form with that action, and the browser has to raise a real submit event.
   A fetch raises none. form.submit() raises none either — that is the method,
   not the event — which is what was wrong here.

   So this script no longer posts anything. It validates, and on the way out
   it stands aside and lets the browser submit the form it is attached to.
   What the reviewer wrote is kept in session storage across that trip, so the
   receipt is waiting when the page returns.

   Nothing here publishes anything. The review arrives in the studio's inbox,
   the order number is looked up by hand, and it goes onto the page from
   snippets/mp-rev.liquid. That is the whole point: a badge on this site means
   somebody checked. */
(function () {
  "use strict";

  var STASH = "mp_review_pending";
  var WORDS = ["", "Poor", "Fair", "Good", "Very good", "Excellent"];
  var MIN = 25;   /* characters. Short enough to be fair, long enough to say something. */

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function looksLikeEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || "").trim());
  }

  /* ------------------------------------------------- the panel --------- */

  function wire() {
    var dlg = $("[data-review-dialog]");
    if (!dlg || dlg.dataset.mpr) return;
    dlg.dataset.mpr = "1";

    var form   = $("[data-review-form]", dlg);
    var live   = $("[data-review-live]", dlg);
    var done   = $("[data-review-done]", dlg);
    var line   = $("[data-review-doneline]", dlg);
    var foot   = $("[data-review-foot]", dlg);
    var send   = $("[data-review-send]", dlg);
    var rate   = $("[data-review-rate]", dlg);
    var say    = $("[data-review-say]", dlg);
    var agree  = $("[data-review-agree]", dlg);
    var errBox = $("[data-review-err]", dlg);
    if (!form) return;

    var body  = $("#mpr-body", dlg);
    var name  = $("#mpr-name", dlg);
    var email = $("#mpr-email", dlg);
    var tick  = agree ? $("input", agree) : null;
    var stars = rate ? $$("label[data-star]", rate) : [];
    var radios = rate ? $$("input[data-star]", rate) : [];

    /* The panel scrolls and its footer is pinned to the bottom of it, so a
       message written at the foot of the body lands behind the button. It is
       said here instead, on a strip directly above it, which never scrolls
       away. The same strip the other two panels use. */
    var strip = document.createElement("p");
    strip.className = "mpq-status";
    strip.setAttribute("role", "status");
    strip.setAttribute("aria-live", "polite");
    strip.hidden = true;
    if (foot && foot.parentNode) foot.parentNode.insertBefore(strip, foot);

    function status(kind, msg) {
      if (!msg) {
        strip.hidden = true;
        strip.textContent = "";
        strip.removeAttribute("data-kind");
        return;
      }
      strip.textContent = msg;
      strip.setAttribute("data-kind", kind);
      strip.hidden = false;
    }

    function flag(el) {
      if (!el) return;
      el.classList.add("is-bad");
      if (el.scrollIntoView) el.scrollIntoView({ block: "center" });
      try { el.focus(); } catch (e) {}
      el.addEventListener("input", function clear() {
        el.classList.remove("is-bad");
        status("", "");
        el.removeEventListener("input", clear);
      });
    }

    /* ---- the stars --------------------------------------------------- */

    function picked() {
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return i + 1;
      return 0;
    }
    function paint(n) {
      stars.forEach(function (l, i) { l.classList.toggle("on", i < n); });
      if (say) say.textContent = n ? (n + " out of 5 — " + WORDS[n]) : "Pick a rating";
    }
    function hover(n) {
      stars.forEach(function (l, i) { l.classList.toggle("hot", n > 0 && i < n); });
    }
    stars.forEach(function (l, i) {
      l.addEventListener("mouseenter", function () { hover(i + 1); });
    });
    /* The label is not focusable; the radio behind it is. Arrow keys move
       between radios, so the preview has to follow the radio or the picker is
       silent to a keyboard. */
    radios.forEach(function (r, i) {
      r.addEventListener("focus", function () { hover(i + 1); });
      r.addEventListener("blur", function () { hover(0); });
    });
    if (rate) {
      rate.addEventListener("mouseleave", function () { hover(0); });
      rate.addEventListener("change", function () {
        if (rate) rate.classList.remove("is-bad");
        status("", "");
        paint(picked());
      });
    }
    paint(0);

    if (tick) {
      tick.addEventListener("change", function () {
        if (tick.checked && agree) agree.classList.remove("is-bad");
        if (tick.checked) status("", "");
      });
    }

    /* ---- opening and closing ----------------------------------------- */

    function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute("open"); }
    $$("[data-review-close]", dlg).forEach(function (b) { b.addEventListener("click", close); });
    dlg.addEventListener("click", function (e) { if (e.target === dlg) close(); });

    $$("[data-review-open]").forEach(function (b) {
      b.addEventListener("click", function () {
        /* A second trip starts from the form again, not from the receipt. */
        if (live) live.hidden = false;
        if (foot) foot.hidden = false;
        if (done) done.hidden = true;
        status("", "");
        if (dlg.showModal) { if (!dlg.open) dlg.showModal(); }
        else dlg.setAttribute("open", "");
        window.setTimeout(function () {
          /* The first star, not the fifth. Opening a review form with five
             stars lit is a thumb on the scale. */
          var first = radios.length ? radios[0] : null;
          if (first && first.focus) { try { first.focus({ preventScroll: true }); } catch (e) {} }
        }, 40);
      });
    });

    /* ---- the receipt -------------------------------------------------- */

    function markSent(who, open) {
      if (live) live.hidden = true;
      if (foot) foot.hidden = true;
      if (done) done.hidden = false;
      if (line) {
        line.textContent = "We read every one. If you left an order number we will"
          + " match it before your review goes up, and we will write to "
          + (who || "you") + " when it does.";
      }
      if (open) {
        if (dlg.showModal) { if (!dlg.open) dlg.showModal(); }
        else dlg.setAttribute("open", "");
      }
    }

    /* ---- sending ------------------------------------------------------ */

    /* preventDefault only when something is wrong. A valid form is allowed
       through to the browser, because Shopify's captcha script is listening
       for this same event further up and cannot do its job if we swallow it. */
    function stop(e) { e.preventDefault(); if (send) send.disabled = false; }

    form.addEventListener("submit", function (e) {
      var stars_n = picked();
      if (!stars_n) {
        stop(e);
        if (rate) rate.classList.add("is-bad");
        status("bad", "Choose a rating first — how many stars out of five?");
        if (rate && rate.scrollIntoView) rate.scrollIntoView({ block: "center" });
        return;
      }
      var text = (body && body.value || "").trim();
      if (text.length < MIN) {
        stop(e);
        status("bad", "Tell us a little more — a sentence or two is plenty.");
        flag(body);
        return;
      }
      if (!(name && name.value.trim())) {
        stop(e);
        status("bad", "We need a name to publish it under.");
        flag(name);
        return;
      }
      if (!looksLikeEmail(email && email.value)) {
        stop(e);
        status("bad", "That email does not look right. It is never published — we only use it to write back.");
        flag(email);
        return;
      }
      if (tick && !tick.checked) {
        stop(e);
        if (agree) agree.classList.add("is-bad");
        status("bad", "Please confirm you bought and used this stand.");
        if (agree && agree.scrollIntoView) agree.scrollIntoView({ block: "center" });
        return;
      }

      if (errBox) { errBox.hidden = true; errBox.textContent = ""; }
      if (send) send.disabled = true;
      status("busy", "Sending your review…");

      /* Everything below this line belongs to the browser and to Shopify's
         own captcha script. Keep the name so the receipt can use it when the
         page comes back, and then do nothing — no preventDefault, no fetch.
         Calling preventDefault here, or posting by hand, is exactly what sent
         the review off without a token. */
      try {
        window.sessionStorage.setItem(STASH, JSON.stringify({
          path: window.location.pathname,
          who: name.value.trim()
        }));
      } catch (err) {}

      /* If the writer closes the captcha challenge instead of answering it,
         no navigation happens and the button would sit disabled for ever. The
         page takes this timer with it when it leaves. */
      window.setTimeout(function () {
        if (send) send.disabled = false;
        status("", "");
      }, 25000);
    });

    /* ---- read them all ------------------------------------------------ */

    $$("[data-review-more]").forEach(function (b) {
      b.addEventListener("click", function () {
        var band = b.closest ? b.closest("[data-reviews]") : null;
        if (!band) return;
        band.setAttribute("data-all", "1");
        var wrap = b.parentNode;
        if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
      });
    });
  }

  /* ------------------------------------------------- the way back ------ */

  function settle() {
    if (window.location.search.indexOf("contact_posted=true") < 0) return;
    var raw = null;
    try { raw = window.sessionStorage.getItem(STASH); } catch (e) {}
    if (!raw) return;
    try { window.sessionStorage.removeItem(STASH); } catch (e) {}
    var st;
    try { st = JSON.parse(raw); } catch (e) { return; }
    if (!st || st.path !== window.location.pathname) return;

    var dlg = $("[data-review-dialog]");
    if (!dlg) return;
    var live = $("[data-review-live]", dlg);
    var foot = $("[data-review-foot]", dlg);
    var done = $("[data-review-done]", dlg);
    var line = $("[data-review-doneline]", dlg);
    if (live) live.hidden = true;
    if (foot) foot.hidden = true;
    if (done) done.hidden = false;
    if (line) {
      line.textContent = "We read every one. If you left an order number we will"
        + " match it before your review goes up, and we will write to "
        + (st.who || "you") + " when it does.";
    }
    if (dlg.showModal) { if (!dlg.open) dlg.showModal(); }
    else dlg.setAttribute("open", "");

    if (window.history && history.replaceState) {
      var sp = new URLSearchParams(window.location.search);
      sp.delete("contact_posted");
      sp.delete("form_type");
      var qs = sp.toString();
      history.replaceState(null, "", window.location.pathname + (qs ? "?" + qs : ""));
    }
  }

  function boot() { wire(); settle(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", wire);
})();
